domoEmbedsApi.$inject = ['$http', '$q', 'configuration']

export default function domoEmbedsApi($http, $q, config) {
  const endPoint = config.apiEndPoint
  const getApiUrl = (path) => `${endPoint}`.replace('/api/v1', '/api/v2') + path;

  return {
    listEmbeds: function() {
      return $http.get(getApiUrl('/domo_embeds')).then(response => ({ data: response.data }));
    },

    getEmbed: function(embedId) {
      return $http.get(getApiUrl(`/domo_embeds/${encodeURIComponent(embedId)}`)).then(response => ({ data: response.data }));
    },

    createEmbed: function(embed) {
      return $http.post(getApiUrl('/domo_embeds'), embed).then(response => ({ data: response.data }));
    },

    updateEmbed: function(embed) {
      return $http.put(getApiUrl(`/domo_embeds/${encodeURIComponent(embed.embed_id)}`), embed).then(response => ({ data: response.data }));
    },

    deleteEmbed: function(embedId) {
      return $http.delete(getApiUrl(`/domo_embeds/${encodeURIComponent(embedId)}`)).then(response => ({ data: response.data }));
    },
  };
}
